import { useState } from 'react';
import { BackroomLogsPage } from './BackroomLogsPage';
import { AccessPage } from './AccessPage';

type Tab = 'logs' | 'access';

const TABS: { id: Tab; label: string; icon: string }[] = [
  { id: 'logs',   label: 'Live Logs',      icon: 'fa-solid fa-file-lines'    },
  { id: 'access', label: 'Access Control', icon: 'fa-solid fa-shield-halved' },
];

export function BackroomsPage() {
  const [tab, setTab] = useState<Tab>('logs');

  return (
    <div className="flex flex-col gap-0 animate-fadeIn">
      {/* Tab bar */}
      <div className="flex items-center gap-1 mb-6">
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold uppercase tracking-wider transition-all border ${
              tab === t.id
                ? 'bg-cyberGreen/10 border-cyberGreen/20 text-cyberGreen shadow-[0_0_12px_rgba(0,255,102,0.08)]'
                : 'bg-white/[0.02] border-white/[0.06] text-slate-500 hover:text-slate-300 hover:bg-white/[0.04]'
            }`}
          >
            <i className={`${t.icon} text-xs`} />
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'logs'   && <BackroomLogsPage />}
      {tab === 'access' && <AccessPage />}
    </div>
  );
}
